// Runtime configuration resolver.
//
// Values are injected at container startup via /env-config.js (see
// docker-entrypoint.sh), which sets `window._env_`. Those take priority so the
// same prebuilt image can be pointed at different backends via Docker
// environment/secrets without rebuilding.
//
// When no runtime value is present (local dev, or a var left unset) we fall back
// to the build-time values baked in by webpack's DefinePlugin. Note: DefinePlugin
// only substitutes literal `process.env.<NAME>` references, so each fallback must
// be spelled out statically below — `process.env[key]` would NOT be replaced.
const buildTime = {
  AUTH_API: process.env.AUTH_API,
  GPR_API: process.env.GPR_API,
  LOGGING_API: process.env.LOGGING_API,
  API_KEY: process.env.API_KEY,
  COOKIE_STAGE: process.env.COOKIE_STAGE,
  COOKIE_DOMAIN: process.env.COOKIE_DOMAIN,
  OIDC_AUTHORITY: process.env.OIDC_AUTHORITY,
  OIDC_CLIENT_ID: process.env.OIDC_CLIENT_ID,
  OIDC_API_SCOPE: process.env.OIDC_API_SCOPE,
  MAPBOX_API_TOKEN: process.env.MAPBOX_API_TOKEN
};

const runtime = (typeof window !== 'undefined' && window._env_) || {};

// Treat empty strings and unsubstituted "${VAR}" placeholders as "not set".
const isUsable = (value) =>
  value !== undefined && value !== null && value !== '' && !/^\$\{.*\}$/.test(value);

export const getConfig = (key) => (isUsable(runtime[key]) ? runtime[key] : buildTime[key]);
